import React from 'react';
import { Card, Form, Input, Button, Select, App } from 'antd';
import { useNavigate } from 'react-router-dom';
import { IUserFormCreateValues } from '../../../types/user';

const UserCreate: React.FC = () => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = (values: IUserFormCreateValues) => {
    // TODO: Implement user creation
    console.log('Create user with values:', values);
    message.success('this feature is coming soon!');
  };

  return (
    <Card title="Create New User">
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Please input user name!' }]}>
          <Input />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Please input user email!' },
            { type: 'email', message: 'Please enter a valid email!' },
          ]}>
          <Input />
        </Form.Item>

        <Form.Item
          label="Roles"
          name="roles"
          rules={[{ required: true, message: 'Please select at least one role!' }]}>
          <Select mode="multiple" allowClear>
            <Select.Option value="USER">User</Select.Option>
            <Select.Option value="ADMIN">Admin</Select.Option>
            <Select.Option value="CONTRACTOR">Contractor</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Create User
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={() => navigate('/admin/users')}>
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default UserCreate;
